import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';

import { IItemRenderer } from '../../interfaces/item-renderer.table';

@Component({
  selector: 'opt-number-item-renderer',
  templateUrl: './number-item-renderer.component.html',
  styleUrls: ['./number-item-renderer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NumberItemRendererComponent implements OnInit, IItemRenderer {
  @Input() id: string;
  @Input() value: number;

  constructor() {}

  ngOnInit(): void {}
}
